import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Form,
  FormGroup,
  Input
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import SvgViewer from '../../../commons/SvgViewer';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';

class TeremKiosztasContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      kiosztasViewStatus: 'LOAD',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      kiosztasSvg: {},
      // MODAL UTILS
      modalView: false,
      modalForm: false,
      saveButtonLoading: false,
      // UTILS
      szektorok: [],
      currentId: null,

      statusz: [],
      statuszOptions: [],
      filterOptions: {},

      formAllapot: null,
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.initTeremKiosztas();
    }
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  initTeremKiosztas = (id) => {
    if (id) {
      Services.initTeremKiosztas(id, (err, res) => {
        if (!err) {
          this.setState({
            formStatus: 'DATA',
            formAllapot: id && res[0].kiosztas && res[0].kiosztas.allapot,
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    } else {
      this.setState({
        tableStatus: 'LOAD'
      }, () => {
        Services.initTeremKiosztas(null, (err, res) => {
          if (!err) {
            let filters = {};
            let options = res[0].statusz.map((e) => {
              filters[e.name] = e.caption;

              return <option key={e.name} value={e.name}>{e.caption}</option>;
            });

            this.setState({
              tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
              baseJson: res[0].list,
              statusz: res[0].statusz,
              statuszOptions: options,
              filterOptions: filters,
            });
          } else {
            this.setState({
              tableStatus: 'NETW'
            });
          }
        });
      });
    }
  }

  handleViewClick = (id) => {
    this.setState({
      kiosztasViewStatus: 'LOAD',
      modalView: true,
      currentId: id,
    });
    Promise.all([
      this.getTeremkiosztas(id)
    ])
      .then(() => {
        this.setState({
          kiosztasViewStatus: 'DATA'
        });
      })
      .catch(() => {
        this.setState({
          kiosztasViewStatus: 'NETW'
        });
      });
  }

  handleTeremEditClick = (id) => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat("/admin/torzsadatok/helyszin/teremterkepmodositas?id=" + id));
  }

  handleTeremNewClick = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat("/admin/torzsadatok/helyszin/teremterkepmodositas"));
  }

  handleTeremDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleTeremDuplicateClick = (cell) => {
    this.setState({
      dupeId: cell
    }, () => {
      this.toggleDuplicateModal();
    });
  }

  toggleDuplicateModal = () => {
    this.setState(prevState => ({ modalDupe: !prevState.modalDupe }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  handleEditClick = (id) => {
    this.setState({
      formType: 'MOD',
      currentId: id,
      modalForm: true
    }, () => {
      this.initTeremKiosztas(id);
    });
  }

  getTeremkiosztas = (id) => {
    return new Promise((resolve, reject) => {
      Services.getTeremkiosztas(id, (err, res) => {
        if (!err) {
          this.setState({
            kiosztasSvg: res[0],
            szektorok: res[0].init.sectors
          }, () => {
            resolve(res[0]);
          });
        } else {
          reject(new Error('Hálozati hiba!'));
        }
      });
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  deleteTeremterkep = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteTeremterkep(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.initTeremKiosztas();
        this.props.globals.addSuccess('Teremkiosztás törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  dupeTeremterkep = () => {
    this.setState({
      dupeButtonLoading: true
    });
    Services.dupeTeremterkep(this.state.dupeId, this.state.newAzon, this.state.newName, (err) => {
      if (!err) {
        this.toggleDuplicateModal();
        this.initTeremKiosztas();
        this.props.globals.addSuccess('Teremkiosztás duplikálva!');
        this.setState({
          dupeButtonLoading: false
        });
      } else {
        this.setState({
          dupeButtonLoading: false
        });
      }
    });
  }

  submitForm = () => {
    const {
      currentId,
      formAllapot,
      formType,
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {

    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.allapot = this.emptyOrNull(formAllapot);

      Services.modifyTeremkiosztas(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Teremkiosztás módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.initTeremKiosztas();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS']) && (
            <React.Fragment>
              <Button
                className="icon-eye table-action-icon"
                id={'action-view-' + cell + 'kiosztas-view'}
                style={{ background: 'transparent' }}
                onClick={() => this.handleViewClick(cell)}
                onMouseDown={(e) => { if (e) { e.preventDefault(); } }}
              />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'kiosztas-view'} delay={50}>
                {'Megtekintés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'], true) && (
            <React.Fragment>
              <Button
                className="icon-pencil table-action-icon"
                id={'action-view-' + cell + 'kiosztas-modositas'}
                style={{ background: 'transparent' }}
                onClick={() => this.handleTeremEditClick(cell)}
                onMouseDown={(e) => { if (e) { e.preventDefault(); } }}
              />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'kiosztas-modositas'} delay={50}>
                {'Módosítás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'], true) && (
            <React.Fragment>
              <Button
                className="icon-plus table-action-icon"
                id={'action-view-' + cell + 'kiosztas-duplikalas'}
                style={{ background: 'transparent' }}
                onClick={() => this.handleTeremDuplicateClick(cell)}
                onMouseDown={(e) => { if (e) { e.preventDefault(); } }}
              />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'kiosztas-duplikalas'} delay={50}>
                {'Duplikálás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {/*this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'], true) && (
            <React.Fragment>
              <Button
                className="icon-organization table-action-icon"
                id={'action-view-' + cell + 'teremterkep-modositas'}
                style={{ background: 'transparent' }}
                onClick={() => this.handleTeremEditClick(cell)}
                onMouseDown={(e) => { if (e) { e.preventDefault(); } }}
              />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'teremterkep-modositas'} delay={50}>
                {'Teremtérkép módosítása'}
              </UncontrolledTooltip>
            </React.Fragment>
          )*/}
          {this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'], true) && (
            <React.Fragment>
              <Button
                className="icon-trash table-action-icon"
                id={'action-view-' + cell + 'kiosztas-delete'}
                style={{ background: 'transparent' }}
                onClick={() => this.handleTeremDeleteClick(cell)}
                onMouseDown={(e) => { if (e) { e.preventDefault(); } }}
              />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'kiosztas-delete'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      // case 'FEL':
      //   return 'Új teremkiosztás létrehozása';
      case 'MOD':
        return 'Teremkiosztás módosítása';
      default:
        return '';
    }
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'terem',
        text: 'Terem',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'azon',
        text: 'Teremkiosztás kód',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Teremkiosztás név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'ulo',
        text: 'Helyre szóló (fő)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'right',
          width: '120px'
        },
        sort: true,
      },
      {
        dataField: 'all',
        text: 'Nem helyre szóló (fő)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'right',
          width: '120px'
        },
        sort: true,
      },
      {
        dataField: 'sum',
        text: 'Összes hely (fő)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'right',
          width: '120px'
        },
        sort: true,
      },
      {
        dataField: 'allapot',
        align: 'center',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter,
        style: {
          width: '120px',
        }
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          headerClasses="table-th"
          wrapperClasses="table-responsive"
          classes="table-scroll"
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderKiosztasView = () => {
    return (
      <React.Fragment>
        {this.renderKiosztasViewTitle()}
      </React.Fragment>
    );
  }

  renderKiosztasViewTitle = () => {
    const {
      kiosztasSvg,
      szektorok
    } = this.state;

    return (
      <React.Fragment>
        <p style={{ fontSize: '1rem', color: 'gray', margin: 0 }}>{kiosztasSvg.vna} - {kiosztasSvg.hna}</p>
        <p style={{ fontSize: '1.25rem' }}>
          <b>{kiosztasSvg.nam}</b>
          {' (' + kiosztasSvg.cod + ') :'}
        </p>
        <SvgViewer
          height="600px"
          fromAdmin={true}
          data={kiosztasSvg}
          twoColorMode
          szektorok={szektorok}
          szinek={{
            coa: '#fff',
            con: '#fff',
            cop: '#fff'
          }}
          onSeatClick={() => { }}
          onAreaClick={() => { }}
        />
      </React.Fragment>
    );
  }

  renderForm = () => {
    const {
      formAllapot,
      formType
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <RFField
              type="select"
              name="formAllapot"
              label="Állapot: *"
              onChange={this.handleInputChange}
              value={this.state.formAllapot}
              selectOptions={this.state.statuszOptions}
              required
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  hasRoleKarb = () => {
    if (this.props.globals.hasRole(['JEGYTERMEK_TEREMKIOSZTAS'], true)) return true;
    return false;
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleTeremNewClick}>Új teremkiosztás hozzáadása</Button>
                </div>
              )
              : <div />
          }
        </div>
        <div className="row">
          <div className="col-md-12">
            {{
              LOAD: (<Loader />),
              DATA: (<DataEmptyState
                hasImage
                subtitle="Vigyél fel új tételt!"
              />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => { this.initTeremKiosztas(); }}
              />),
              TABL: (this.renderTable())
            }[this.state.tableStatus]}
          </div>
        </div>
        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static" size="lg">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => { this.handleViewClick(this.state.currentId) }}
              />),
              DATA: (this.renderKiosztasView())
            }[this.state.kiosztasViewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteTeremterkep()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDupe} toggle={this.toggleDuplicateModal} backdrop="static">
          <ModalHeader>Teremkiosztás duplikálása</ModalHeader>
          <ModalBody>
            <Form>
              <div className="row">
                <div className="col-sm-12" style={{ marginBottom: 4 }}>
                  <Label for="newAzon">
                    Új azonosító
                  </Label>
                  <Input
                    id="newAzon"
                    name="newAzon"
                    onChange={this.handleInputChange}
                    value={this.state.newAzon}
                  // placeholder="with a placeholder"
                  //type="tx"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Label for="newName">
                    Új név
                  </Label>
                  <Input
                    id="newName"
                    name="newName"
                    onChange={this.handleInputChange}
                    value={this.state.newName}
                  //placeholder="with a placeholder"
                  //type="email"
                  />
                </div>
              </div>
            </Form>
          </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.dupeTeremterkep()}
              loading={this.state.dupeButtonLoading}
            >
              {'OK'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDuplicateModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <RFForm
          onSubmit={this.submitForm}
          modalInsert
          title={this.renderFormTitle()}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal, backdrop: 'static', size: 'sm' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { }}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
        </RFForm>
      </React.Fragment>
    );
  }
}

TeremKiosztasContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default TeremKiosztasContent;